import { Routes } from '@angular/router';
import { BIDashboardsComponent } from './BI-dashboards.component';
import { DashboardAccessGuard } from './dashboard-access.guard';
export const BI_DASHBOARDS_ROUTES: Routes = [
  {
    path: 'dashboards',
    component: BIDashboardsComponent,
    children: [
      {
        path: 'labor-dashboard',
        title: 'Labor Dashboard',
        loadComponent: () =>
          import(
            './pages/dashboard-track-two/dashboard-track-two.component'
          ).then(m => m.DashboardTrackTwoComponent),
        canActivate: [DashboardAccessGuard],
      },
      {
        path: 'safety-dashboard',
        title: 'safety Dashboard',
        loadComponent: () =>
          import('./pages/dashboard-safety/dashboard-safety.component').then(
            m => m.DashboardSafetyComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'labor-dashboard',
        pathMatch: 'full',
      },
    ],
  },
];
